var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styles from './Switch.module.scss';
var Switch = function (_a) {
    var checked = _a.checked, disabled = _a.disabled, label = _a.label, labelLeft = _a.labelLeft, className = _a.className, id = _a.id, dataId = _a.dataId, onChange = _a.onChange;
    return (_jsxs("section", __assign({ className: styles.SwitchWrapper }, { children: [!!label && labelLeft && _jsx("span", __assign({ className: "".concat(styles.Label, " ").concat(styles.Left) }, { children: label })), _jsxs("label", __assign({ id: id, className: "".concat(styles.Switch, " ").concat(className), "data-testid": dataId }, { children: [_jsx("input", { type: 'checkbox', onChange: function () { return onChange(!checked); }, checked: checked, disabled: disabled }), _jsx("div", { className: styles.Slider })] })), !!label && !labelLeft && _jsx("span", __assign({ className: styles.Label }, { children: label }))] })));
};
Switch.propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.string,
    labelLeft: PropTypes.bool,
    checked: PropTypes.bool.isRequired,
    id: PropTypes.string,
    dataId: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};
export { Switch };
//# sourceMappingURL=Switch.js.map